import React, { useState, useEffect } from 'react';
import './UserManagement.css';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [selectedType, setSelectedType] = useState('All');
  const [searchEmail, setSearchEmail] = useState('');

  useEffect(() => {
    // Fetch the list of users from the API using fetch
    fetch('https://back.startupconnectz.com/api/admin/users')
      .then((response) => response.json())
      .then((data) => setUsers(data.users))
      .catch((error) => console.error('Error fetching users:', error));
  }, []);

  const handleRemoveUser = (userId) => {
    // Delete user using fetch
    fetch(`https://back.startupconnectz.com/api/admin/user/${userId}`, {
      method: 'DELETE',
    })
      .then((response) => response.json())
      .then((data) => {
        alert(data.message);
        // Update the user list after removal
        setUsers(users.filter((user) => user.id !== userId));
      })
      .catch((error) => {
        alert('Error removing user');
        console.error(error);
      });
  };

  const filteredUsers = users.filter((user) => {
    const matchesType = selectedType === 'All' || user.userType === selectedType;
    const matchesEmail = user.email && user.email.toLowerCase().includes(searchEmail.toLowerCase()); // Add a check here
    return matchesType && matchesEmail;
  });
  
  return (
    <div className="user-mgmt-container">
      <h2 className="user-mgmt-title">User Management</h2>

      {/* Filter Section */}
      <div className="user-mgmt-filters">
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          className="user-mgmt-dropdown"
        >
          <option value="All">All Users</option>
          <option value="Investor">Investor</option>
          <option value="Startup">Startup</option>
          <option value="Mentor">Mentor</option>
        </select>

        <input
          type="text"
          placeholder="Search by Email"
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          className="user-mgmt-search-input"
        />
      </div>

      <div className="user-mgmt-list">
  <div className="user-mgmt-row header">
    <span className="user-mgmt-name">Name</span>
    <span className="user-mgmt-type">User Type</span> {/* Corrected to display User Type */}
    <span className="user-mgmt-email">Email</span>
    <span className="user-mgmt-time">Time/Date</span> {/* Corrected to display Time */}
    <span className="user-mgmt-actions">Actions</span>
  </div>
  {filteredUsers.map((user) => (
    <div className="user-mgmt-row" key={user.id}>
      <div className="user-mgmt-column name">
        {user.image ? (
          <img src={user.image} alt={user.name} className="user-mgmt-image" />
        ) : (
          <div className="user-mgmt-initials">{user.initials || user.name[0]}</div>
        )}
        <span className="user-mgmt-name-text">{user.name}</span>
      </div>
      <div className="user-mgmt-column type">
        <span className="user-mgmt-type-text">{user.userType}</span> {/* Display userType */}
      </div>
      <div className="user-mgmt-column email">
        <span className="user-mgmt-email-text">{user.email}</span>
      </div>
      <div className="user-mgmt-column time">
        <span className="user-mgmt-time-text">{new Date(user.createdAt).toLocaleString()}</span> {/* Format time */}
      </div>
      <div className="user-mgmt-column actions">
        <button className="user-mgmt-remove-btn" onClick={() => handleRemoveUser(user.id)}>Remove</button>
      </div>
    </div>
  ))}
</div>
    </div>
  );
};

export default UserManagement;
